module.exports = __webpack_public_path__ + "files/14e4798524f0e24fe4bafd816f747dfa.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-1.png
// module id = 1627
// module chunks = 60